import * as a from "./actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: false,
  tauxCouverture: []
};

export function tauxCouverture(state = INITIAL_STATE, action) {
  switch (action.type) {
    case a.GET_TAUX_COUVERTURE.REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
        error: false
      };
    case a.GET_TAUX_COUVERTURE.SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: null,
        tauxCouverture: action.payload
      };
    case a.GET_TAUX_COUVERTURE.FAILURE:
      return {
        ...state,
        success: false,
        error: true,
        loading: false
      };
    case a.RESET_TAUX_COUVERTURE:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export default tauxCouverture;
